import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import CookieBanner from "./components/CookieBanner";
import ChatBot from "./components/ChatBot";
import PromoPopup from "./components/PromoPopup";
import Home from "./pages/Home";
import Membership from "./pages/Membership";
import Classes from "./pages/Classes";
import PersonalTraining from "./pages/PersonalTraining";
import Pilates from "./pages/Pilates";
import Spa from "./pages/Spa";
import Contact from "./pages/Contact";
import About from "./pages/About";
import Privacy from "./pages/Privacy";
import Imprint from "./pages/Imprint";
import Terms from "./pages/Terms";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/membership" element={<Membership />} />
          <Route path="/classes" element={<Classes />} />
          <Route path="/personal-training" element={<PersonalTraining />} />
          <Route path="/pilates" element={<Pilates />} />
          <Route path="/spa" element={<Spa />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/about" element={<About />} />
          <Route path="/datenschutz" element={<Privacy />} />
          <Route path="/impressum" element={<Imprint />} />
          <Route path="/agb" element={<Terms />} />
        </Routes>
        <Footer />
        <CookieBanner />
        <ChatBot />
        <PromoPopup />
      </BrowserRouter>
    </div>
  );
}

export default App;
